import { takeUntil } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute, Router } from '@angular/router';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { Component, Input, OnDestroy, ChangeDetectorRef, Inject, PLATFORM_ID } from '@angular/core';

import { VisualsType } from '@sifca-monorepo/ecommerce-generator';
import { PointOfSaleType } from '@sifca-monorepo/ecommerce-generator';
import { LandingPageTypeEnum, UserType } from '@sifca-monorepo/ecommerce-generator';

import { LanguageService } from '../../services/language/language.service';
import { AuthService, LandingPagesService, PosService, UserService, UtilsService, VisualsService } from '../../services';

@Component({
  template: '',
})
export class BaseHeaderComponent implements OnDestroy {
  @Input() containerClass = 'container';
  protected unsubscribeAll: Subject<any> = new Subject<any>();

  wishCount = 0;
  flagvalue: any;
  user: UserType;
  cookieValue: any;
  valueset: string;
  authenticated: boolean;
  pos$: Observable<PointOfSaleType>;
  visuals$: Observable<VisualsType>;

  listLang = [
    { text: 'English', flag: 'assets/flags/us.svg', lang: 'en-gb' },
    { text: 'Français', flag: 'assets/flags/fr.svg', lang: 'fr-fr' },
  ];

  constructor(
    protected router: Router,
    protected posService: PosService,
    protected clientAuthService: AuthService,
    protected userService: UserService,
    protected utilsService: UtilsService,
    protected activeRoute: ActivatedRoute,
    protected cookiesService: CookieService,
    protected visualsService: VisualsService,
    protected languageService: LanguageService,
    protected changeDetectorRef: ChangeDetectorRef,
    protected landingPagesService: LandingPagesService,
    @Inject(DOCUMENT) protected document: Document,
    @Inject(PLATFORM_ID) protected platformId: Object,
  ) {
    this.pos$ = this.posService.pos$;
    this.visuals$ = this.visualsService.visuals$;
    this.clientAuthService.authenticated$.subscribe((authenticated: boolean) => {
      this.authenticated = authenticated;
      this.changeDetectorRef.markForCheck();
    });

    this.cookieValue = localStorage.getItem('elvklang') || 'fr-fr';
    const val = this.listLang.find((x) => x.lang === this.cookieValue);
    if (!val) {
      if (this.flagvalue === undefined) {
        this.valueset = 'assets/flags/us.svg';
      }
    } else {
      this.flagvalue = val?.flag;
    }
    this.userService.user$.pipe(takeUntil(this.unsubscribeAll)).subscribe((user: UserType) => {
      this.user = user;
      this.changeDetectorRef.markForCheck();
    });
  }

  setLanguage(lang: string, flag: string) {
    if (isPlatformBrowser(this.platformId)) {
      this.flagvalue = flag;
      this.cookieValue = lang;
      this.languageService.setLanguage(lang);
      const langData = { lang };
      window.postMessage(langData, '*');
      const fullPath = this.router.url;
      if (fullPath.includes('/contact')) {
        this.landingPagesService.findLandingPagesByTargetAndTypePaginated([LandingPageTypeEnum.CONTACT]).subscribe();
      }
      if (fullPath.includes('/about')) {
        this.landingPagesService.findLandingPagesByTargetAndTypePaginated([LandingPageTypeEnum.ABOUT]).subscribe();
      }
      if (fullPath.includes('/terms')) {
        this.landingPagesService.findLandingPagesByTargetAndTypePaginated([LandingPageTypeEnum.TERMS]).subscribe();
      }
      if (fullPath.includes('/faq')) {
        this.landingPagesService.findLandingPagesByTargetAndTypePaginated([LandingPageTypeEnum.FAQ]).subscribe();
      }
      if (fullPath.includes('/privacy')) {
        this.landingPagesService.findLandingPagesByTargetAndTypePaginated([LandingPageTypeEnum.PRIVACY]).subscribe();
      }
    }
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next(true);
    this.unsubscribeAll.complete();
  }
}
